import React from "react";

function Canvas_Linear_Gradient() {
  return (
    <div>
      <h1>Canvas_Linear_Gradient Component</h1>
      <p>This is the Canvas Linear Gradient tutorial page content.</p>
    </div>
  );
}

export default Canvas_Linear_Gradient;
